import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import { deleteAdminCase } from "shared/actions/admin/adminCaseActions";
import { CaseAdminDetail } from "shared/reducers/admin/adminCaseReducer";

import { PathologyWatchButton } from "components/customInputs/buttons/Button";

import WarningDialog from "../WarningDialog";

type CaseWarningDialogProps = {
  adminCase: CaseAdminDetail;
  setIsDeleting: Function;
  historyState?: { label: string; prevUrl: string };
  errorMessage?: string;
  resetErrorMessage: Function;
};

const CaseWarningDialog = ({
  adminCase,
  setIsDeleting,
  historyState,
  errorMessage,
  resetErrorMessage,
}: CaseWarningDialogProps) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    return () => resetErrorMessage();
  }, []);

  const onDeleteCase = () => {
    dispatch(
      deleteAdminCase({
        adminCase: adminCase,
        navigate,
        historyState,
      })
    );
  };

  return (
    <WarningDialog
      onClose={() => setIsDeleting(false)}
      title="Delete this Case"
    >
      <div className="CaseWarningDialog">
        <span>Would you like to delete this case?</span>
        {errorMessage && <p className="errorMessage">{errorMessage}</p>}
        <div className="actions__container">
          <PathologyWatchButton onClick={() => setIsDeleting(false)}>
            Cancel
          </PathologyWatchButton>
          <PathologyWatchButton
            type="submit"
            color="red"
            onClick={onDeleteCase}
          >
            Delete
          </PathologyWatchButton>
        </div>
      </div>
    </WarningDialog>
  );
};

export default CaseWarningDialog;
